import React, { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import BackArrow from './icons/BackArrow';


interface Props {
  color?: string;
  onBackClick?: () => void;
  rightContent?: ReactNode;

}

const PageTitle = ({ color = 'var(--shine-background-text-color)', onBackClick, children, rightContent }: PropsWithChildren<Props>) => {
  return <ActionBar $color={color}>
    {onBackClick !== undefined ? <BackArrowContainer onClick={onBackClick}>
      <BackArrow size={18}/>
    </BackArrowContainer> : <SpacerDiv>&nbsp;</SpacerDiv>}
    <Title>
      {children}
    </Title>
    {rightContent !== undefined ? rightContent : <SpacerDiv>&nbsp;</SpacerDiv>}
  </ActionBar>;
};


export const ActionBar = styled.div<{ $color: string }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: ${({ $color }) => $color};
  align-items: end;
`;

export const BackArrowContainer = styled.div`
  cursor: pointer;
  width: 25px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 24px;
`;

const SpacerDiv = styled.div`
  width: 25px;
`;


export default PageTitle;
